<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Task Monitor</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <!-- <li class="breadcrumb-item active" aria-current="page">{{ 'TASK.TASK' | translate }}</li> -->

            <li class="breadcrumb-item" aria-current="page">
              {{ "TASK.TASK_OVERVIEW" | translate }}
            </li>
            <li class="filter-sort">
              <div
                class="filter-sort-wrapper"
                (clickOutside)="onClickedOutside()"
              >
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#filter"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-filter"
                    aria-hidden="true"
                    pTooltip="Filter"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideFilter">
                  <ul class="filter-section-wrapper collapse" id="filter">
                    <li class="no-padding-left">
                      <div class="leave-type">
                        <h5>{{ "TASK.TASK_STATUS" | translate }}</h5>
                        <p-multiSelect
                          [options]="taskStatus"
                          [(ngModel)]="selectedStatusId"
                        >
                        </p-multiSelect>
                      </div>
                    </li>
                    <li class="">
                      <div class="col-lg-4 auto-width">
                        <div class="form-group">
                          <h5>{{ "TASK.MONITORING_MATRIX" | translate }}</h5>
                          <p-multiSelect
                            [options]="monitoringMatrixNames"
                            [(ngModel)]="selectedMonitoringMatrix"
                          >
                          </p-multiSelect>
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li>
                      <div class="col-lg-4 auto-width">
                        <div class="form-group">
                          <h5>{{ "TASK.RECURRENCE_TYPE" | translate }}</h5>
                          <label class="radio-inline no-margin-top">
                            <input
                              type="radio"
                              value="0"
                              name="recurranceTaskAll"
                              (change)="recurrenceTypeChanged()"
                              [(ngModel)]="taskOverviewFilter.RecurrenceType"
                            />Show All</label
                          >
                          <label class="radio-inline no-margin-top">
                            <input
                              type="radio"
                              value="1"
                              name="recurranceTaskR"
                              (change)="recurrenceTypeChanged()"
                              [(ngModel)]="taskOverviewFilter.RecurrenceType"
                            />Recurring</label
                          >
                          <label class="radio-inline no-margin-top">
                            <input
                              type="radio"
                              value="2"
                              name="recurranceTaskNR"
                              (change)="recurrenceTypeChanged()"
                              [(ngModel)]="taskOverviewFilter.RecurrenceType"
                            />Non-Recurring</label
                          >
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li *ngIf="taskOverviewFilter.RecurrenceType === '1'">
                      <div class="col-lg-4 auto-width">
                        <div class="form-group">
                          <h5>{{ "TASK.RECURRENCE_PERIOD" | translate }}</h5>
                          <label class="radio-inline no-margin-top">
                            <input
                              type="radio"
                              value="Daily"
                              name="recurrencePeriodD"
                              (change)="recurrenceTypeChanged()"
                              [(ngModel)]="taskOverviewFilter.RecurrencePeriod"
                            />Daily</label
                          >
                          <label class="radio-inline no-margin-top">
                            <input
                              type="radio"
                              value="Weekly"
                              name="recurrencePeriodW"
                              (change)="recurrenceTypeChanged()"
                              [(ngModel)]="taskOverviewFilter.RecurrencePeriod"
                            />Weekly</label
                          >
                          <label class="radio-inline no-margin-top">
                            <input
                              type="radio"
                              value="Monthly"
                              name="recurrencePeriodM"
                              (change)="recurrenceTypeChanged()"
                              [(ngModel)]="taskOverviewFilter.RecurrencePeriod"
                              [checked]="true"
                            />Monthly</label
                          >
                          <label class="radio-inline no-margin-top">
                            <input
                              type="radio"
                              value="Quarterly"
                              name="recurrencePeriodQ"
                              (change)="recurrenceTypeChanged()"
                              [(ngModel)]="taskOverviewFilter.RecurrencePeriod"
                            />Quarterly</label
                          >
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>

                    <li class="">
                      <div class="col-lg-4 auto-width">
                        <div class="form-group">
                          <h5>{{ "TASK.CREATED_DATE" | translate }}</h5>
                          <div
                            class="col-lg-12 col-md-11 col-sm-11 no-padding margin-top-10"
                          >
                            <div
                              class="col-lg-6 col-md-6 col-sm-6 no-padding-left"
                            >
                              <p-calendar
                                [showIcon]="true"
                                [showTime]="true"
                                placeholder="From"
                                [(ngModel)]="fromDate"
                                dateFormat="dd/mm/yy"
                                class="custom-datepicker"
                                readonlyInput="true"
                                required
                                #timeOfUse="ngModel"
                                monthNavigator="true"
                                yearNavigator="true"
                                yearRange="1950:2100"
                                showButtonBar="true"
                              >
                              </p-calendar>
                            </div>
                            <div
                              class="col-lg-6 col-md-6 col-sm-6 no-padding-right"
                            >
                              <p-calendar
                                [showIcon]="true"
                                [minDate]="fromDate"
                                [showTime]="true"
                                placeholder="To"
                                dateFormat="dd/mm/yy"
                                [(ngModel)]="toDate"
                                class="custom-datepicker"
                                readonlyInput="true"
                                required
                                #timeOfUse="ngModel"
                                monthNavigator="true"
                                yearNavigator="true"
                                yearRange="1950:2100"
                                showButtonBar="true"
                              ></p-calendar>
                            </div>
                            <div class="clearfix"></div>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li class="no-padding-right">
                      <h5>Unit</h5>
                      <p-multiSelect
                        [options]="unitList"
                        [(ngModel)]="selectedUnit"
                      ></p-multiSelect>
                    </li>
                    <li class="no-padding-right">
                      <h5>Section</h5>
                      <p-multiSelect
                        [options]="sectionList"
                        [(ngModel)]="selectedSection"
                      ></p-multiSelect>
                    </li>

                    <div class="clearfix"></div>
                    <li class="filter-footer">
                      <footer>
                        <a
                          (click)="resetValue()"
                          role="button"
                          class="btn btn-primary primary-btn button-reset"
                        >
                          <i class="fa fa-refresh"></i>reset
                        </a>
                        <a
                          (click)="doneFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-submit"
                        >
                          <i class="fa fa-check"></i>done
                        </a>
                      </footer>
                    </li>
                  </ul>
                </div>
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#sort"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-sort"
                    aria-hidden="true"
                    pTooltip="Sort"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideSort">
                  <ul
                    class="filter-section-wrapper sort-section-wrapper collapse"
                    id="sort"
                  >
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{ "TASK.ID" | translate }}</label>
                          <a class="selected">
                            <i
                              (click)="ascTaskId()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="">
                            <i
                              (click)="descTaskId()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="no-margin-right">
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{ "TASK.TASK_DATE" | translate }}</label>
                          <a class="">
                            <i
                              (click)="ascTaskDate()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="selected">
                            <i
                              (click)="descTaskDate()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </li>
          </ol>
        </nav>
        <div class="section-wrapper">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div
              class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10"
            >
              <a
                [ngClass]="
                  taskListResponse.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="exportToExcel()"
                class="btn btn-primary primary-btn export-btn button-excel"
                role="button"
              >
                <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To Excel
              </a>
              <a
                [ngClass]="
                  taskListResponse.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="downloadZIP()"
                class="btn btn-primary primary-btn export-btn button-zip"
                role="button"
              >
                <i class="fa fa-file-zip-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To ZIP
              </a>
            </div>
            <div
              class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right"
            >
              <input
                type="text"
                placeholder="Search"
                class="form-control search-obs"
                [(ngModel)]="searchText"
                (keyup.enter)="searchData()"
              />
              <button class="btn btn-primary primary-btn">
                <i
                  class="fa fa-search search"
                  (click)="searchData()"
                  [class.padding]="searchText.length > 0"
                ></i>
                <i
                  class="fa fa-close clear"
                  *ngIf="searchText.length > 0"
                  (click)="clearSearch()"
                ></i>
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div class="table-responsive margin-top-15 observation-table">
            <table class="table table-hover table-striped fix-tablelayout">
              <thead>
                <tr>
                  <th style="width: 30px">
                    <input
                      type="checkbox"
                      [checked]="isTasksChecked"
                      (change)="selectAllTasks($event.target.checked)"
                      [(ngModel)]="isTasksChecked"
                      [value]="isTasksChecked"
                    />
                  </th>
                  <th style="width: 80px">{{ "TASK.ID" | translate }}</th>
                  <th style="width: 100px">
                    {{ "TASK.UNIT_NAME" | translate }}
                  </th>
                  <!-- <th style="width: 180px"> -- requested by client to remove 30.12.24
                   Contract Number 
                  </th>
                  <th style="width: 180px">
                    Contract Holder Name
                  </th> -->
                  <th style="width: 180px">
                    {{ "TASK.TASK_NAME" | translate }}
                  </th>
                  <th style="width: 180px">{{ "TASK.MATRIX" | translate }}</th>
                  <th style="width: 280px">{{ "TASK.SECTION" | translate }}</th>
                  <th style="width: 80px">
                    {{ "TASK.RECURRENCE_PERIOD" | translate }}
                  </th>
                  <th style="width: 100px">
                    {{ "TASK.CREATED_DATE" | translate }}
                  </th>
                  <th style="width: 100px">{{ "TASK.ACTIVE" | translate }}</th>
                  <th style="width: 120px">
                    {{ "TASK.TASK_STATUS" | translate }}
                  </th>
                  <th style="width: 80px">{{ "TASK.DOWNLOAD" | translate }}</th>
                  	
		              <th style="width: 80px" *ngIf="permissions.SUPER_Admin" >Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  (contextmenu)="cm.show($event); showContextMenu(task)"
                  #row
                  style="cursor: pointer"
                  *ngFor="
                    let task of taskListResponse
                      | paginate
                        : {
                            itemsPerPage: itemsPerPage,
                            currentPage: pageSize,
                            totalItems: rowCount
                          }
                  "
                  id="{{ task.TaskId }}"
                >
                  <td>
                    <span *ngIf="task.Status === 'Draft'">
                      <input
                        type="checkbox"
                        [disabled]="task.Status === 'Draft'"
                        (change)="selectTasks(task, $event)"
                        [value]="task"
                      />
                    </span>
                    <span *ngIf="task.Status !== 'Draft'">
                      <input
                        type="checkbox"
                        [(ngModel)]="task.Checked"
                        [checked]="task.Checked"
                        (change)="selectTasks(task, $event)"
                        [value]="task"
                      />
                    </span>
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    <span *ngIf="task.Status === 'Draft'" style="color: red"
                      >Draft</span
                    >
                    <span *ngIf="task.Status !== 'Draft'"
                      >TSK{{ task.TaskId }}</span
                    >
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.UnitName }}
                  </td>
                  <!-- <td -- requested by client to remove 30.12.24
                  (click)="getCurrentDOMElementId(task.TaskId)"
                  [routerLink]="['/task/create-task', task.TaskId]"
                >
                  {{ task.ContractNumber }}
                </td>
                <td
                (click)="getCurrentDOMElementId(task.TaskId)"
                [routerLink]="['/task/create-task', task.TaskId]"
              >
                {{ task.ContractHolderName }}
              </td> -->
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.Name }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.MatrixName }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.SectionName }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.RecurrencePeriod }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.CreatedDate | dateTimeFormat: "MMM D, YYYY" }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.IsActive }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(task.TaskId)"
                    [routerLink]="['/task/create-task', task.TaskId]"
                  >
                    {{ task.Status }}
                  </td>
                  <td (click)="downloadPDF(task.TaskId)">
                    <i class="fa fa-download"></i>
                  </td>

                  <td *ngIf="permissions.SUPER_Admin">
                    <ara-record-actions *ngIf="task.Status === 'Deleted'" [SourceId]="task.TaskId" ModuleName="Task" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >

                    </ara-record-actions>
                  </td>
				  
                </tr>
              </tbody>
              <div
                style="width: 500px; margin-top: 15px; color: red"
                *ngIf="taskListResponse.length === 0"
              >
                No Records Found!
              </div>
              <div style="width: 500px" *ngIf="taskListResponse.length">
                <pagination-controls
                  (pageChange)="getServerData($event)"
                ></pagination-controls>
              </div>
            </table>
          </div>
          <div class="card-view">
            <label class="checkbox-inline margin-bottom-10 pull-right"
              ><input
                type="checkbox"
                [checked]="isTasksChecked"
                (change)="selectAllTasks($event.target.checked)"
                [(ngModel)]="isTasksChecked"
                [value]="isTasksChecked"
              />Select All</label
            >
            <div class="clearfix"></div>
            <div
              class="card"
              *ngFor="
                let task of taskListResponse
                  | paginate
                    : {
                        itemsPerPage: itemsPerPage,
                        currentPage: pageSize,
                        totalItems: rowCount
                      }
              "
            >
              <div
                [popover]="task.Name"
                popoverTitle="Task Name"
                popoverPlacement="bottom"
                [popoverOnHover]="false"
                [popoverCloseOnClickOutside]="true"
                [popoverCloseOnMouseOutside]="true"
                [popoverDisabled]="false"
                [popoverAnimation]="true"
                [popoverDismissTimeout]="0"
              >
                <h5 class="card-title">
                  <span class="ellepsis-mobile">{{ task.Name }}</span>
                  <span>
                    <input
                      type="checkbox"
                      [(ngModel)]="task.Checked"
                      [checked]="task.Checked"
                      (change)="selectTasks(task, $event)"
                      [value]="task"
                  /></span>
                </h5>
              </div>
              <p
                class="card-sub-title"
                (click)="getCurrentDOMElementId(task.TaskId)"
                [routerLink]="['/task/create-task', task.TaskId]"
              >
                <span>TSK{{ task.TaskId }}</span> -
                <span>{{ task.UnitName }}</span>
              </p>
              <p
                (click)="getCurrentDOMElementId(task.TaskId)"
                [routerLink]="['/task/create-task', task.TaskId]"
              >
                <span>{{ task.CreatedDate | dateTimeFormat }}</span>
              </p>
              <p
                (click)="getCurrentDOMElementId(task.TaskId)"
                [routerLink]="['/task/create-task', task.TaskId]"
              >
                <span>{{ task.IsActive }}</span> -
                <span>{{ task.Status }}</span>
              </p>
            </div>
            <div
              style="margin-top: 15px; color: red"
              *ngIf="taskListResponse.length === 0"
            >
              No Records Found!
            </div>
            <div class="col-sm-12 col-xs-12" *ngIf="taskListResponse.length">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <!-- End table-responsive -->
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<ara-alerts
  [alertType]="alertType"
  [successDetails]="successDetails"
  [errorDetails]="errorDetails"
  (yesClicked)="onYesClickedForConfirmation()"
  [confirmMessage]="confirmMessage"
  (noClicked)="onNoClickedForConfirmation()"
  (okClicked)="onOkClicked()"
></ara-alerts>
<p-contextMenu
  [appendTo]="row"
  [target]="row"
  #cm
  [model]="contextItems"
></p-contextMenu>
